import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import RadiusUprightOutlinedSvg from "@ant-design/icons-svg/es/asn/RadiusUprightOutlined";
import AntdIcon from "../components/AntdIcon";
var RadiusUprightOutlined = function RadiusUprightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RadiusUprightOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  RadiusUprightOutlined.displayName = 'RadiusUprightOutlined';
}
export default /*#__PURE__*/React.forwardRef(RadiusUprightOutlined);